import { MeasuredModel, ModelType } from "./entities/Model";
/**
 * Width and projection is used to calculate the number of modules
 * required for the given values. This is used solely for rendering the object
 * the same way the server calculates the price.
 * @param shouldRotate
 * @param model
 * @param width
 * @param projection
 */
export function measureModules(shouldRotate, model, width, projection) {
    if (!model)
        return;
    let moduleQty;
    let moduleWidth;
    let moduleProjection;
    let rotated = false;
    let canRotate = false;
    let modulesX;
    let modulesZ;
    switch (model.type) {
        case ModelType.BIOCLIMATIC: {
            const moduleQtyNormal = (Math.ceil(width / model.maxWidth) * Math.ceil(projection / model.maxProjection));
            const moduleQtyRotated = (Math.ceil(projection / model.maxWidth) * Math.ceil(width / model.maxProjection));
            if (moduleQtyNormal <= moduleQtyRotated) {
                moduleQty = moduleQtyNormal;
                moduleWidth = width / Math.ceil(width / model.maxWidth);
                moduleProjection = projection / Math.ceil(projection / model.maxProjection);
            }
            else if (shouldRotate === false) {
                moduleQty = moduleQtyNormal;
                moduleWidth = width / Math.ceil(width / model.maxWidth);
                moduleProjection = projection / Math.ceil(projection / model.maxProjection);
                canRotate = true;
            }
            else {
                rotated = true;
                canRotate = true;
                moduleQty = moduleQtyRotated;
                moduleWidth = projection / Math.ceil(projection / model.maxWidth);
                moduleProjection = width / Math.ceil(width / model.maxProjection);
            }
            break;
        }
        default: {
            moduleQty = (Math.ceil(width / getMaxWidthForProjection(model, projection)) * Math.ceil(projection / model.maxProjection));
            moduleWidth = width / Math.ceil(width / getMaxWidthForProjection(model, projection));
            moduleProjection = projection / Math.ceil(projection / model.maxProjection);
            break;
        }
    }
    modulesZ = rotated ? projection / moduleWidth : width / moduleWidth;
    modulesX = rotated ? width / moduleProjection : projection / moduleProjection;
    return new MeasuredModel(model, moduleWidth, moduleProjection, moduleQty, rotated, canRotate, modulesX, modulesZ);
}
function getMaxWidthForProjection(model, projection) {
    const roundedProjection = Math.ceil(projection / 50) * 50;
    if (roundedProjection > 700) {
        return model.maxProjection - roundedProjection + 1000;
    }
    else {
        return model.maxWidth;
    }
}
